// This list must match the languageAlternatives list
// for the 'codeblock' type in Apparat's sanity project
export const supportedLanguages = [
  { title: 'Bash', value: 'bash' },
  { title: 'C#', value: 'csharp' },
  { title: 'CSS', value: 'css' },
  { title: 'Dart', value: 'dart' },
  { title: 'Elixir', value: 'elixir' },
  { title: 'Go', value: 'go' },
  { title: 'HTML', value: 'html' },
  { title: 'Java', value: 'java' },
  { title: 'JavaScript', value: 'javascript' },
  { title: 'JSON', value: 'json' },
  { title: 'JSX', value: 'jsx' },
  { title: 'Kotlin', value: 'kotlin' },
  { title: 'Markdown', value: 'markdown' },
  { title: 'Plain text', value: 'text' },
  { title: 'Python', value: 'python' },
  { title: 'SASS', value: 'sass' },
  { title: 'Swift', value: 'swift' },
  { title: 'TypeScript', value: 'typescript' },
  { title: 'XML', value: 'xml' },
  { title: 'YAML', value: 'yaml' },
];

export function getTitleForLanguage(language: string): string | null {
  const match = supportedLanguages.find((lang) => lang.value === language);
  return match?.title || null;
}
